export default from './floating-action-button';



// WEBPACK FOOTER //
// ./app/components/floating-action-button/index.js